// modules
import XLSX from 'xlsx'

export default {
  cursorToEnd: (contentEditableElement) => {
    let range
    let selection
    if (document.createRange) {
      // Firefox, Chrome, Opera, Safari, IE 9+
      range = document.createRange() // Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement) // Select the entire contents of the element with the range
      range.collapse(false) // collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection() // get the selection object (allows you to change selection)
      selection.removeAllRanges() // remove any selections already made
      selection.addRange(range) // make the range you have just created the visible selection
    } else if (document.selection) {
      // IE 8 and lower
      range = document.body.createTextRange() // Create a range (a range is a like the selection but invisible)
      range.moveToElementText(contentEditableElement) // Select the entire contents of the element with the range
      range.collapse(false) // collapse the range to the end point. false means collapse to end rather than the start
      range.select() // Select the range (make it the visible selection
    }
  },
  inputCursorToEnd: (input) => {
    let originalValue = input.val()
    input.val('')
    input.focus().val(originalValue)
  },
  count (obj) {
    var count = 0
    for (let i in obj) { // eslint-disable-line
      count++
    }
    return count
  },
  getColLabel (colIndex) {
    let label = ''
    let availableLabels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
    while (colIndex > 0) {
      let i = colIndex % availableLabels.length

      if (colIndex + 1 < availableLabels.length) {
        i--
      }

      label = availableLabels[i] + label
      colIndex = Math.floor(colIndex / availableLabels.length)
    }
    return label
  },
  getColIndex (colLabel) {
    let availableLabels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
    let colIndex = 0

    if (colLabel.length > 1) {
      let labelParts = colLabel.split('')
      labelParts = labelParts.map((part) => {
        return availableLabels.indexOf(part) + 1
      })
      for (let i = 0; i < labelParts.length; i++) {
        if (i + 1 === labelParts.length) {
          colIndex += labelParts[i]
        } else {
          colIndex += Math.pow((availableLabels.length * labelParts[i]), i + 1)
        }
      }
    } else {
      colIndex = availableLabels.indexOf(colLabel) + 1
    }
    return (colIndex >= availableLabels.length) ? colIndex - 1 : colIndex
  },
  readExcelFile (file, callback) {
    var reader = new FileReader()

    reader.onload = (e) => {
      var data = e.target.result
      var workbook = XLSX.read(data, {
        type: 'binary'
      })

      workbook.SheetNames.forEach((sheetName) => {
        var sheetData = workbook.Sheets[sheetName]
        let result = {}

        for (let key in sheetData) {
          if (key[0] === '!') continue
          result[key] = sheetData[key].w
        }

        callback(result)
      })
    }

    reader.onerror = (ex) => {
      console.log(ex)
    }

    reader.readAsBinaryString(file)
  },
  excelFromClipboard (e, callback) {
    e.preventDefault()
    let cb
    let clipText = ''
    if (window.clipboardData && window.clipboardData.getData) {
      cb = window.clipboardData
      clipText = cb.getData('Text')
    } else if (e.clipboardData && e.clipboardData.getData) {
      cb = e.clipboardData
      clipText = cb.getData('text/plain')
    } else {
      cb = e.originalEvent.clipboardData
      clipText = cb.getData('text/plain')
    }
    let clipRows = clipText.split('\n')
    for (let i = 0; i < clipRows.length; i++) {
      clipRows[i] = clipRows[i].split('\t')
    }
    let jsonObj = []
    for (let i = 0; i < clipRows.length - 1; i++) {
      let item = {}
      for (let j = 0; j < clipRows[i].length; j++) {
        if (clipRows[i][j] !== '\r') {
          if (clipRows[i][j].length !== 0) {
            item[j] = clipRows[i][j]
          }
        }
      }
      jsonObj.push(item)
    }

    let result = {}

    for (let i in jsonObj) {
      let row = jsonObj[i]
      for (let j in row) {
        let cell = this.$getColLabel(+j + 1) + (+i + 1)
        let value = jsonObj[i][j]
        result[cell] = value
      }
    }

    callback(result)
  },
  buildACLRule (subject, actions) {
    let rule = {
      subject,
      actions: []
    }
    let rules = []

    for (let action in actions) {
      if (actions[action]) rule.actions.push(action)
    }

    rules[subject] = rule

    return rules
  },
  isInViewport (elem) {
    var bounding = elem.getBoundingClientRect()
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  },
  assignDashboardModelReader (models) {
    return (model) => {
      try {
        let val = eval(`models.${model}`) // eslint-disable-line
        if (val === undefined) throw new Error()
        return val
      } catch (err) {
        console.error(err)
        return null;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js